<template>
  <div class="nheader">
    <!--  -->
    <div class="shead">
      <div class="nwsc" @click="$router.push('/baoming')">

        <h1>新型电力系统博士生创新论坛</h1>
      </div>

    </div>

  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "",
  data() {
    return {
     
    };
  },
  created() {
    console.log(this.$store.state.userInfo);
  },
  mounted() {},

  methods: {
    gohome() {
      this.$router.push("/");
    },
   
  },
};
</script>

<style scoped lang="less">
.nheader{
.shead {
    
    background: url("./../../assets/image/hbgok.jpg") center no-repeat;

    .nwsc {
      padding-top: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 150px;

      h1{
          color: #0062b5;
        font-size: 3rem;
      }
    }
  }

  
}

</style>



// WEBPACK FOOTER //
// src/components/header/header.vue